export default "__VITE_ASSET__RL6yeYXq__"